import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    token: null,
    isUserLoggedIn: false,
    selectedUser: null,
    selectedSticker: null,
    selectedOrder: null,
    cart: [],
    totalNumberInCart: 0,
    shippingInfo: null
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      if (token) {
        state.isUserLoggedIn = true;
      } else {
        state.isUserLoggedIn = false;
      }
    },
    setUser(state, user) {
      state.user = user;
    },
    setSelectedUser(state, user) {
      state.selectedUser = user;
    },
    setSelectedSticker(state, sticker) {
      state.selectedSticker = sticker;
    },
    setSelectedOrder(state, order) {
      state.selectedOrder = order;
    },
    addToTotalInCart(state, quantity) {
      state.totalNumberInCart = state.totalNumberInCart + quantity;
    },
    addToCart(state, itemDetails) {
      let alreadyInCart = false;
      state.cart.forEach(cartItem => {
        if (
          cartItem.itemID == itemDetails.itemID &&
          cartItem.size == itemDetails.size
        ) {
          alreadyInCart = true;
          cartItem.quantity = cartItem.quantity + itemDetails.quantity;
        }
      });
      if (alreadyInCart == false) {
        state.cart.push(itemDetails);
      }
    },
    setEntireCart(state, cartItems) {
      state.cart = cartItems;
    },
    setShippingInfo(state, shippingInfo) {
      state.shippingInfo = shippingInfo;
    },
    addAddress(state, address) {
      state.user.addressBook.push(address);
    },
    clearDefaultAddress(state) {
      state.user.addressBook.forEach(address => {
        address.default = false;
      });
    },
    setAddressBook(state, addressBook) {
      state.user.addressBook = addressBook;
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit("setToken", token);
    },
    setUser({ commit }, user) {
      commit("setUser", user);
    },
    setSelectedUser({ commit }, user) {
      commit("setSelectedUser", user);
    },
    setSelectedSticker({ commit }, sticker) {
      commit("setSelectedSticker", sticker);
    },
    setSelectedOrder({ commit }, order) {
      commit("setSelectedOrder", order);
    },
    addToCart({ commit }, itemDetails) {
      commit("addToCart", itemDetails);
    },
    addToTotalInCart({ commit }, quantity) {
      commit("addToTotalInCart", quantity);
    },
    setEntireCart({ commit }, carItems) {
      commit("setEntireCart", carItems);
    },
    setShippingInfo({ commit }, shippingInfo) {
      commit("setShippingInfo", shippingInfo);
    },
    addAddress({ commit }, address) {
      commit("addAddress", address);
    },
    clearDefaultAddress({ commit }) {
      commit("clearDefaultAddress");
    },
    setAddressBook({ commit }, addressBook) {
      commit("setAddressBook", addressBook);
    }
  },
  plugins: [createPersistedState()]
});
